import api from '@/api/manager'
import { MANAGER_SET } from '../types'

export default {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    [MANAGER_SET] (state, data) {
      state.data = data
    }
  },
  actions: {
    async getProfiles ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      const clientId = await dispatch('Auth/getClientId', null, {root: true})
      return api.getProfiles(clientId).then(response => {
        if (response.data) {
          this.data = response.data
          commit(MANAGER_SET, response.data)
        }
        dispatch('Global/hideLoading', null, {root: true})
      })
    },
    async addProfile ({dispatch}, value) {
      dispatch('Global/showLoading', null, {root: true})
      const clientId = await dispatch('Auth/getClientId', null, {root: true})
      return api.addProfile(clientId, value).then(() => {
        // atualiza lista
        dispatch('getProfiles')
      })
    },
    async removeProfile ({dispatch}, value) {
      dispatch('Global/showLoading', null, {root: true})
      const clientId = await dispatch('Auth/getClientId', null, {root: true})
      return api.removeProfile(clientId, value).then(() => {
        // atualiza lista
        dispatch('getProfiles')
      })
    }
  }
}
